<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-process
            type="search"
            label="공정"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="기간"
            name="period"
            :isToyear="true"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="TBM 목록"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="신규" icon="add" @btnClicked="linkClick" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
// import selectConfig from '@/js/selectConfig';
export default {
  name: 'tbm',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '사업장',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col00',
            field: 'col00',
            label: 'TBM No',
            align: 'center',
            type: 'link',
            sortable: false,
          },
          {
            name: 'col01',
            field: 'col01',
            label: '작업허가 No',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '공정명',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '작업내용',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '일자',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '진행상태',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '회사명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col6',
            field: 'col6',
            label: '작업책임자',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col7',
            field: 'col7',
            label: '외',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col8',
            field: 'col8',
            label: '허가서구분',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col9',
            field: 'col9',
            label: '허가자',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col10',
            field: 'col10',
            label: '허가시간',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col11',
            field: 'col11',
            label: '종료일시',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      period: ['', ''],
      searchParam: {
        startYmd: '',
        endYmd: '',
        plantCd: '',
        processCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        // isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col0: '사업장1', 
          col00: 'TBM2100653',
          col01: '2021-01398',
          col1: '반응1공정', 
          col2: 'PCM(압연) 작업', 
          col3: '2022-02-08', 
          col4: '작성완료', 
          col5: '(주)아쿠아', 
          col6: '김길동', 
          col7: '3명', 
          col8: '일반위험', 
          col9: '홍길동', 
          col10: '2022-02-08', 
          col11: '2022-02-08', 
        },
        {
          col0: '사업장1', 
          col00: 'TBM2100654',
          col01: '2021-01592',
          col1: 'REACTOR OB-005', 
          col2: '유틸리티 교체작업', 
          col3: '2022-01-04', 
          col4: '작성완료', 
          col5: '직영', 
          col6: '이길동', 
          col7: '4명', 
          col8: '일반위험', 
          col9: '김길동', 
          col10: '2022-01-04', 
          col11: '2022-01-04', 
        },
        {
          col0: '사업장1', 
          col00: 'TBM2100655',
          col01: '2021-01398',
          col1: '반응1공정', 
          col2: '기계설비공사', 
          col3: '2022-02-08', 
          col4: '작성완료', 
          col5: '(주)엡스엔지니어링', 
          col6: '김길동', 
          col7: '5명', 
          col8: '일반위험', 
          col9: '홍길동', 
          col10: '2022-02-08', 
          col11: '2022-02-08', 
        },
      ];
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () =>
      import(`${"./tbmDetail.vue"}`);
      this.popupOptions.title = 'TBM 상세';
      this.popupOptions.param = {
        col00: result.col00,
      };
      this.popupOptions.width = '95%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
